/**
 * Error message displayed to user when auth token has expired
 *
 * @private
 */
export const EXPIRED_TOKEN_MESSAGE = "Your session has expired. Please login again.";

/**
 * Error message displayed to the user when the auth token is invalid
 *
 * @private
 */
export const INVALID_TOKEN_MESSAGE = "An error caused you to be logged out. Please login again.";

/**
 * Error message displayed to the user when the temporary token is expired
 *
 * @private
 */
export const EXPIRED_TEMPORARY_TOKEN_MESSAGE = "The link to set your password has expired. A request for a new link has been sent. Please check your email and follow the instructions.";

/**
 * Error message displayed to the user when teh temporary token is invalid
 *
 * @private
 */
export const INVALID_TEMPORARY_TOKEN_MESSAGE = "There was a problem setting your password. PLease try clicking the link in your email again. If the problem persists, please contact support";
